import "../App.css";

const NotFound = () => {
  return (
    <div className="not-found">
      <div>
        <h1>ERROR 404</h1>
      </div>
      <div>
        <h1>PAGE NOT FOUND</h1>
      </div>
    </div>
  );
};

export default NotFound;
